// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"4bcb5e2c","213":"eab6a00c","245":"cbaffa46","289":"dca0e4f1","355":"4d3edb89","453":"d855a71b","472":"1d1d3272","570":"dcc8247e","681":"0c04e6b5","682":"a4497dad","718":"6e1997ba","732":"0eb8fd42","972":"e3fa50fe","977":"eb3d8fb6"}[chunkId] + ".chunk.js";
};